export default __webpack_public_path__ + "static/media/PowerGrotesk-Heavy.73b02601.woff";